export default{
  getSearchBlogsStatus: (state) => state.searchBlogsStatus,
  getSearchBlogsCategory: (state) => state.searchBlogsCategory
}



// WEBPACK FOOTER //
// ./src/components/blogs/store/getters.js